<template>
    <div class="bg-primary newsletter-wrapper"
         style="background: linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)), url('https://images.unsplash.com/photo-1523995462485-3d171b5c8fa9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=675&q=80') !important; background-size: cover !important;">
        <div class="container">
            <div class="GridLex-grid-middle">
                <div class="GridLex-col-6_sm-12_xs-12 pt-0 pb-0">
                    <div class="text-holder">
                        <h3>Suscríbete a nuestra Newsletter</h3>
                        <p>Suscríbete ahora para recibir las últimas novedades, ofertas y descuentos</p>
                    </div>
                </div>
                <div class="GridLex-col-6_sm-12_xs-12 pt-0 pb-0">
                    <form class="footer-newsletter row gap-10">
                        <div class="col-xss-12 col-xs-8 col-sm-8">
                            <input type="email" placeholder="Introduce tu E-Mail" class="form-control mb-0"
                                   name="email">
                        </div>
                        <div class="col-xss-12 col-xs-4 col-sm-4 mt-10-xss">
                            <input type="submit" class="btn btn-block btn-danger" value="Enviar">
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'newsletter'
    }
</script>